// extracted by mini-css-extract-plugin
module.exports = {"message":"Error_message__3R-jZ"};